import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../Components/Alert.tsx";
import { urlutenti } from "../lib/api.ts";
import "./PasswordDimenticata.css";

interface PasswordDimenticataProps {
  show: boolean;
  onClose: () => void;
}

const PasswordDimenticata: React.FC<PasswordDimenticataProps> = ({
  show,
  onClose,
}) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const showAlert = useAlert();
  const navigate = useNavigate();

  const errorInputStyle = {
    border: "1px solid red",
  };

  const handleInvia = async () => {
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setEmailError(true);
      showAlert(
        "danger",
        "Errore",
        "Inserisci un indirizzo email valido.",
        "bottom-end",
        3000
      );
      return;
    }

    try {
      const response = await fetch(
        `${urlutenti}/password-dimenticata?email=${encodeURIComponent(email)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.ok) {
        showAlert(
          "success",
          "Email Inviata",
          "Se questa e-mail è registrata, riceverai a questo indirizzo il codice di verifica per reimpostare la password.",
          "bottom-end",
          8000
        );
        onClose();
        setTimeout(() => {
          navigate("/reset-password");
        }, 500);
      } else {
        const errorData = await response.json();
        showAlert(
          "danger",
          "Errore",
          errorData.message || "Errore durante l'invio dell'email.",
          "bottom-end",
          3000
        );
      }
    } catch (error) {
      showAlert(
        "danger",
        "Errore",
        "Errore durante la richiesta.",
        "bottom-end",
        3000
      );
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Password Dimenticata</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Inserisci il tuo indirizzo e-mail per ricevere un codice di verifica e
          reimpostare la password.
        </p>
        <Form.Group controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Inserisci la tua email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(false);
            }}
            style={emailError ? errorInputStyle : {}}
            className="large-input"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          className="button-annulla"
          onClick={onClose}
        >
          Annulla
        </Button>
        <Button variant="primary" className="button" onClick={handleInvia}>
          Invia
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PasswordDimenticata;
